React = require 'react/addons'
Router = require 'react-router'
Link = Router.Link
AgeVerification = require '../../actions/age-verification'
ProductStore = require '../../stores/product-store'
{ Link, State } = Router
classSet = React.addons.classSet

module.exports = React.createClass
  displayName: 'Navigation'

  mixins: [Router.Navigation, State]

  resetAgeVerification: (event) ->
    event.preventDefault()
    AgeVerification.reset()
    @transitionTo 'age-gate'

  # render: ->
  #   aboutClasses = classSet { 'nav-about': true, 'selected': @isActive 'about' }
  #   followClasses = classSet { 'nav-follow': true, 'selected': @isActive 'follow' }
  #   productsClasses = classSet { 'nav-products': true, 'selected': @isActive 'product' }
  #
  #   <nav>
  #     <ul ref='navigationList' className='nav nav-stacked'>
  #       <li className={aboutClasses}><Link to='about'>About</Link></li>
  #       <li className={productsClasses}><Link to='product' params={ productId: ProductStore.products[0].key }>Products</Link></li>
  #       <li className={followClasses}><Link to='follow'>Follow</Link></li>
  #       <li className='nav-contact'><a href='mailto:info@santeratequila.com'>Contact</a></li>
  #       <li className='nav-reset'><a href='#' onClick={@resetAgeVerification}>Reset</a></li>
  #     </ul>
  #   </nav>

  # <li className='nav-reset'><a href='#' onClick={@resetAgeVerification}>Reset</a></li>
  render: ->
    aboutClasses = classSet { 'nav-about': true, 'selected': @isActive 'about' }
    filmClasses = classSet { 'nav-film': true, 'selected': @isActive 'film' }
    productsClasses = classSet { 'nav-products': true, 'selected': @isActive 'product' }

    React.createElement("nav", null,
      React.createElement("ul", {"ref": 'navigationList', "className": 'nav nav-stacked'},
        React.createElement("li", {"className": (aboutClasses)}, React.createElement(Link, {"to": 'about'}, "About")),
        React.createElement("li", {"className": (filmClasses)}, React.createElement(Link, {"to": 'film'}, "Film")),
        React.createElement("li", {"className": (productsClasses)}, React.createElement(Link, {"to": 'product', "params": ( productId: ProductStore.products[0].key )}, "Products")),
        React.createElement("li", {"className": 'nav-tumblr'}, React.createElement("a", {"href": 'http://santera-tequila.tumblr.com'}, "Tumblr")),
        React.createElement("li", {"className": 'nav-instagram'}, React.createElement("a", {"href": 'http://instagram.com/SanteraTequila'}, "Instagram")),
        React.createElement("li", {"className": 'nav-contact'}, React.createElement("a", {"href": 'mailto:info@santeratequila.com'}, "Contact"))
      )
    )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/shared/navigation.cjsx
 **/